import React from 'react';
import { factoryExpenseListMeta } from '../../constants/factoryExpenseCategories';
import { EXPENSE_CATEGORY_VALUES } from '../../constants/expenseCategories';
import { useLanguage } from '../../i18n/LanguageContext';
import ExpenseCategoryList from './ExpenseCategoryList';

const OfficeExpenses = ({ user, onAddExpense }) => {
  const { t, lang } = useLanguage();
  const meta = factoryExpenseListMeta(EXPENSE_CATEGORY_VALUES.OFFICE, user, lang);
  return (
    <ExpenseCategoryList
      user={user}
      category="office"
      title={meta?.title || t('exp.list.office.title')}
      lede={meta?.lede || t('exp.list.office.lede')}
      onAddExpense={onAddExpense}
    />
  );
};

export default OfficeExpenses;
